import { Base } from '../base-component';

import './carousel-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from 'services/media-query.service';

export class CarouselItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/carousel-item/carousel-item.component.ts